@if (division) {
  <div [innerHTML]="'meterreadings.info.meternumberInfo' | translate: { division: divisionTranslated }"></div>
} @else {
  <div [innerHTML]="'meterreadings.info.meternumberInfoGeneral' | translate"></div>
}

<div class="re-flex re-flex-row re-mt-15 mobile-only">
  <img [src]="'assets/img/meter-tooltip-' + divisionPicture.toLowerCase() + '-s.png'" alt="{{ 'meterreadings.info.infoPictureAlt' | translate }}">
</div>
  
<div class="re-flex re-flex-row re-mt-15 tablet-up-only">
  <img [src]="'assets/img/meter-tooltip-' + divisionPicture.toLowerCase() + '-xl.png'" alt="{{ 'meterreadings.info.infoPictureAlt' | translate }}">
</div>
